<template>
  <ApplicantsDialog
    v-if="item.type == 'Creator'"
    data-qa="purch-toolbar-applicants-dialog"
    :item="item"/>
  <DateRangeDialog
    v-else-if="item.type == 'Period'"
    data-qa="purch-toolbar-date-range"
    :search.sync="item.search"/>
</template>

<script>
import Statuses from 'components/common/blocks/Statuses.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'
import ApplicantsDialog from 'components/purchasing/filters/ApplicantsDialog.vue'

export default {
  name: 'purchFilters',
  props: {
    item: Object,
  },
  methods: {
    async setItems() {
      return await this.$store.dispatch('getStatuses')
    },
  },
  components: {
    Statuses,
    DateRangeDialog,
    ApplicantsDialog
  }
}
</script>
